import {
    createApp
} from 'vue'
import {
    createRouter,
    createWebHistory
} from 'vue-router';
import ViewUIPlus from 'view-ui-plus'
import 'view-ui-plus/dist/styles/viewuiplus.css'
import store from './store/store'
import util from './utils/util'
import App from './App.vue'
import Layout from './views/homeFrame.vue'

// 路由配置
const router = createRouter({
    esModule: false,
    mode: 'history',
    history: createWebHistory(),
    routes: [
        // {
        //     path: '/',
        //     component: () => import('./views/pageIndex.vue')
        // },
        {
            path: '/login',
            component: () => import('./views/pageIndex.vue')
        },
        {
            path: '',
            component: Layout,
            redirect: 'welcome',
            children: [{
                path: 'welcome',
                component: () => import('./views/welcomeFirst'),
                name: 'Welcome',
                meta: {
                    title: 'welcome',
                    noCache: true
                }
            }]
        },
        {
            path: '/system',
            component: Layout,
            redirect: 'noredirect',
            name: '系统管理',
            alwaysShow: true,
            meta: {
            },
            children: [{
                    path: 'user',
                    component: () => import('./views/system/userIndex.vue'),
                    name: 'user',
                    meta: {
                        noCache: true
                    }
                },
                {
                    path: 'role',
                    component: () => import('./views/system/roleIndex.vue'),
                    name: 'role',
                    meta: {
                        noCache: true
                    }
                },
                {
                    path: 'config',
                    component: () => import('./views/system/configIndex.vue'),
                    name: 'config',
                    meta: {
                        noCache: true
                    }
                }
            ]
        },
        {
            path: '/manage',
            component: Layout,
            redirect: 'noredirect',
            name: '审核管理',
            alwaysShow: true,
            meta: {
            },
            children: [{
                    path: 'sharefileManage',
                    component: () => import('./views/manage/sharefileManage.vue'),
                    name: 'sharefileManage',
                    meta: {
                        noCache: true
                    }
                },
                {
                    path: 'dispatchManage',
                    component: () => import('./views/manage/dispatchManage.vue'),
                    name: 'dispatchManage',
                    meta: {
                        noCache: true
                    }
                },
                {
                    path: 'intentionManage',
                    component: () => import('./views/manage/intentionManage.vue'),
                    name: 'intentionManage',
                    meta: {
                        noCache: true
                    }
                },
                {
                    path: 'exhibitionReview',
                    component: () => import('./views/manage/exhibitionReview.vue'),
                    name: 'exhibitionReview',
                    meta: {
                        noCache: true
                    }
                },
                {
                    path: 'delayReview',
                    component: () => import('./views/manage/delayReview.vue'),
                    name: 'delayReview',
                    meta: {
                        noCache: true
                    }
                },
                {
                    path: 'errorReview',
                    component: () => import('./views/manage/errorReview.vue'),
                    name: 'errorReview',
                    meta: {
                        noCache: true
                    }
                },
                {
                    path: 'operation',
                    component: () => import('./views/manage/operationIndex.vue'),
                    name: 'operation',
                    meta: {
                        noCache: true
                    }
                },
                {
                    path: 'param',
                    component: () => import('./views/manage/paramIndex.vue'),
                    name: 'param',
                    meta: {
                        noCache: true
                    }
                },
                {
                    path: 'shareUpload',
                    component: () => import('./views/manage/shareUpload.vue'),
                    name: 'shareUpload',
                    meta: {
                        noCache: true
                    }
                }
            ]
        },
        {
            path: '/sharefile',
            component: Layout,
            redirect: 'noredirect',
            name: '客户资料',
            alwaysShow: true,
            meta: {
            },
            children: [{
                    path: 'sharefile',
                    component: () => import('./views/sharefile/sharefileIndex.vue'),
                    name: 'sharefile',
                    meta: {
                        noCache: true
                    }
                },
                {
                    path: 'personal',
                    component: () => import('./views/sharefile/personfileIndex.vue'),
                    name: 'personal',
                    meta: {
                        noCache: true
                    }
                }
            ]
        },
        {
            path: '/exhibition',
            component: Layout,
            redirect: 'noredirect',
            name: '展会信息',
            alwaysShow: true,
            meta: {
            },
            children: [{
                    path: 'exhibition',
                    component: () => import('./views/exhibition/exhibitionIndex'),
                    name: 'exhibition',
                    meta: {
                        noCache: true
                    }
                },
                {
                    path: 'regPersonal',
                    component: () => import('./views/exhibition/personalIndex'),
                    name: 'regPersonal',
                    meta: {
                        noCache: true
                    }
                },
                {
                    path: 'nativePersonal',
                    component: () => import('./views/exhibition/nativePersonalIndex'),
                    name: 'nativePersonal',
                    meta: {
                        noCache: true
                    }
                }
            ]
        },
        {
            path: '/native',
            component: () => import('./views/nativeHome.vue')
        },
        {
            path: '/nativeSuccess',
            component: () => import('./views/nativeSuccess.vue')
        },
        {
            path: '/pageChoose',
            component: () => import('./views/pageChoose.vue')
        },
    ]
});
const whiteList = ['/login', '/auth-redirect']
router.beforeEach((to, from, next) => {
    const loginTime = localStorage.getItem("logintime");
    const loginToken = localStorage.getItem("loginToken");
    if (loginToken) {
        //如果超过12小时，失效清空，否则正常跳转选择页
        if (loginTime) {
            const now = new Date().getTime();
            if (now > loginTime) {
                localStorage.removeItem("username");
                localStorage.removeItem("password");
                localStorage.removeItem("logintime");
                localStorage.removeItem("loginToken");
                if (to.path !== '/') {
                    next('/');
                } else {
                    next();
                }
            } else {
                next()
            }
        } else {
            if (to.path !== '/') {
                next('/');
            } else {
                next();
            }
        }
    } else {
        if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next()
        } else {
            next(`/login?redirect=${to.path}`)
        }
    }
});

const app = createApp(App)
app.use(ViewUIPlus)
app.use(router);
app.use(store)
app.mount('#app')
app.config.globalProperties.$util = util
app.config.globalProperties.$store = store
export default app